import { DecisionType } from "../../types/commonTypes/decisionType"
import { DurationManagementType } from "../../types/commonTypes/durationManagementType"

export const  decisionWithEffectiveDateInitialState : DecisionType = {
    decisionNature: "",
    decisionDate: "",
   effectiveDate: ""
}

export const  durationInitialState : DurationManagementType = {
    DurationDateDébut: "",
    DurationNature: "",
   DurationDateFin: ""
}

export const  decisionInitialState : DecisionType = {
    decisionNature: "",
    decisionDate: "",
}